module.exports = __webpack_public_path__ + "img/vitawallet_logo.e497919.png";